

















































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon, IconConfig } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwScrollView } from '@libs/unified-ui-framework/src/shared/sw-scroll-view';
import { SwForm, SwFormRow } from '@libs/unified-ui-framework/src/shared/sw-form';

@Component({
  components: {
    SwIcon,
    SwScrollView,
    SwForm,
    SwFormRow,
  },
})
export default class SwSecurityCenterInfoModal extends Vue {

  @Prop()
  svg: boolean;

  @Prop()
  image: string;

  @Prop({ type: [Object, String], required: true })
  icon: IconConfig | string | 'divider';

  @Prop()
  color: string;

  @Prop()
  title: string;

  @Prop()
  count: number;

  @Prop()
  globalCount: number;

  @Prop()
  regionalCount: number;

  @Prop()
  region: string;

  @Prop()
  height: number;

  @Prop()
  width: number;

  @Prop()
  value: boolean;

  displayModal = this.value;

  @Watch('value')
  onDisplayChange(val: boolean) {
    this.displayModal = val;
  }

  @Watch('displayModal')
  onInternalDisplayChange() {
    this.$emit('input', this.displayModal);
  }

  get countWithCommas() {
    if (isNaN(this.count)) { return '0'; }
    return this.count < 1 && this.count > 0 ? 1 : (Math.round(this.count))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  get globalData() {
    if (isNaN(this.globalCount)) { return '0'; }
    return this.globalCount < 1 && this.globalCount > 0 ? 1 : Math.round(this.globalCount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  get regionalData() {
    if (isNaN(this.regionalCount)) { return '0'; }
    return this.regionalCount < 1 && this.regionalCount > 0 ? 1 : Math.round(this.regionalCount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  get regionName() {
    return this.region;
  }

  get effectiveIconConfig(): IconConfig {
    let useConfig: IconConfig | null = null;

    if (typeof this.icon === 'string') {
      useConfig = { name: this.icon };
    } else {
      useConfig = this.icon;
    }

    return Object.assign(
      {
        size: 36,
        color: this.color,
      },
      useConfig,
    );
  }
}
